import { RG_TYPE, deepFlatChildren } from "@project-rouge/rg-core";
import { addOpeningOnPivot, getRgObjectsAtLevel } from "@project-rouge/rg-three";
function addExitDoorsToCores({ building, dataset }) {
	const rvData = dataset.rvData;
	const doorId = dataset.modulousIds.entranceDoorId;
	const needExit = getRgObjectsAtLevel(building, RG_TYPE.Core, 0).filter((c) => c.data.hasExit);
	for (const core of needExit) {
		const floors = deepFlatChildren(core).filter((c) => c.type === RG_TYPE.Floor);
		const heightPivot = (Math.max(...floors.map((f) => f.pos[1] + f.size[1])) + core.anchor[1] * core.size[1]) / core.size[1];
		addOpeningOnPivot({
			obj: core,
			type: RG_TYPE.Door,
			pivot: [
				.5,
				heightPivot,
				1
			],
			rvDataList: rvData,
			modulousId: doorId
		});
	}
}
export { addExitDoorsToCores };

//# sourceMappingURL=index40.js.map